import React, { useState ,useEffect } from "react";
import { Container } from "../components/Grid"
import InventoryGame from "../components/Inventory/inventoryGame"
import CliffWorld from '../features/world/CliffWorld';
import { useParams } from "react-router-dom";
import API from "../utils/API";

function CliffGame() {

    const { id } = useParams();

    const [userAvatar, setUserAvatar] = useState(null)
    const [userAvatarName, setUserAvatarName] = useState(null)

    useEffect(() => {
        // API.getUserSprite(id).then(user => {
        //     const { sprite } = user.data[0].sprite[0]
       
        //         return setUserAvatar(sprite)
        // }).then(() => {API.getUserSprite(id).then(user => {
        //     const { name } = user.data[0].sprite[0]
       
        //     setUserAvatarName(name)
        // })
            
        // })
        const getUserData = async ()=> {
            const userData = await API.getUser(id)
            const user = await userData.json()
            const { sprite, name } = user.sprite[0]
         
            setUserAvatar(sprite)
            setUserAvatarName(name)
        }
  

        getUserData()
    }, []);

    return(
        <div>

                
                <div>
                    {/* Game Board */}
                        <CliffWorld avatar={userAvatar} avatarName={userAvatarName}/>
                </div>

        </div>
    )
}

export default CliffGame;